<div class="wrapper {{ config.containerClass }}" id="cx_{{ componentKey }}" *ngIf="pinForm?.controls" [ngStyle]="config.containerStyles">
  <input
    [pattern]="config.allowNumbersOnly ? '\\d*' : ''"
    [type]="inputType"
    numberOnly
    [placeholder]="config?.placeholder || ''"
    [disabledNumberOnly]="!config.allowNumbersOnly"
    [ngStyle]="config.inputStyles"
    maxlength="4"
    class="recovery-input {{ config.inputClass }}"
    autocomplete="off"
    *ngFor="let item of pinForm?.controls | keys; let i = index"
    [formControl]="pinForm.controls[item]"
    id="otp_{{ i }}_{{ componentKey }}"
    (keydown)="onKeyDown($event)"
    (keyup)="onKeyUp($event, i)"
  />
</div>
